import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel, NgForm }    from '@angular/forms';

/*Pipe*/
import { SafeHtml }                 from './safehtml.pipe';
import { MinuteSecondsPipe }        from './minuteSeconds.pipe';

@NgModule({
  imports: [ 
    CommonModule, FormsModule
  ],
  declarations: [
    SafeHtml, 
    MinuteSecondsPipe
  ],
  exports: [ 
    SafeHtml, 
    MinuteSecondsPipe
  ]
})
export class PipeShareModule { }